'use client';

import { useEffect } from 'react';
import { useMeetingHistory } from './useMeetingHistory';

export function useMeetingTracker() {
  const { completeMeeting, markAsAccessed } = useMeetingHistory();

  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentMeetingId = sessionStorage.getItem('currentMeetingId');
      const meetingStartTime = sessionStorage.getItem('meetingStartTime');

      if (currentMeetingId && meetingStartTime) {
        const startTime = parseInt(meetingStartTime);
        const endTime = Date.now();
        const durationMs = endTime - startTime;

        // Converter duração para formato legível
        const duration = formatDuration(durationMs);

        // Marcar reunião como concluída
        completeMeeting(currentMeetingId, duration, 1); // 1 participante por padrão

        // Limpar sessionStorage
        sessionStorage.removeItem('currentMeetingId');
        sessionStorage.removeItem('meetingStartTime');
        sessionStorage.removeItem('originalRoomName');
      }
    };

    // Registrar início da reunião
    const currentMeetingId = sessionStorage.getItem('currentMeetingId');
    if (currentMeetingId && !sessionStorage.getItem('meetingStartTime')) {
      sessionStorage.setItem('meetingStartTime', Date.now().toString());
      markAsAccessed(currentMeetingId);
    }

    // Escutar eventos de saída da página
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('pagehide', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('pagehide', handleBeforeUnload);
    };
  }, [completeMeeting, markAsAccessed]);

  const formatDuration = (milliseconds: number): string => {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) {
      const remainingMinutes = minutes % 60;
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}min` : `${hours}h`;
    } else if (minutes > 0) {
      return `${minutes}min`;
    } else {
      return `${seconds}s`;
    }
  };
}
